// src/utils/ToastBus.js
import Vue from "vue";
export default new Vue();
